export class UniqueIdGenerator {
  private ids: Set<number>;

  constructor() {
    this.ids = new Set<number>();
  }

  public reset(idArray: number[]) {
    this.ids = new Set<number>(idArray);
  }

  public generateId(): number {
    let id;
    do {
      const min = 0;
      const max = 2147483647;
      return Math.floor(Math.random() * (max - min + 1)) + min; // 含最大值，含最小值
    } while (this.ids.has(id));
  }

  public deprecateId(id: number) {
    this.ids.delete(id);
  }
}
